<template>
  <div class="container">
    <h1 class="text">
      Không tìm thấy trang
    </h1>
    <ms-button @click.stop="onGoBackHome">
      Quay lại trang chủ
    </ms-button>
  </div>
</template>

<script>
import { redirectToApp } from '@/common/common-fn'
import { App } from '@/common/constant'

export default {
  name: 'NotFound',

  methods: {
    onGoBackHome () {
      redirectToApp(App.Account)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .text {
    margin-bottom: 40px;
  }
}
</style>
